var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "options container" },
    [
      _c("ncc-switcher", {
        attrs: { "label-after": _vm.__("label.modus.children") },
        model: {
          value: _vm.isModeForChildren,
          callback: function($$v) {
            _vm.isModeForChildren = $$v
          },
          expression: "isModeForChildren"
        }
      }),
      _vm._v(" "),
      _c("ncc-switcher", {
        attrs: {
          "label-before": _vm.__("label.modus.sv"),
          "label-after": _vm.__("label.modus.hsv")
        },
        model: {
          value: _vm.isModeHsv,
          callback: function($$v) {
            _vm.isModeHsv = $$v
          },
          expression: "isModeHsv"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }